"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[200],{

/***/ 6290:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_StarBadge; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tooltip/dist/index.esm.js
var index_esm = __webpack_require__(7026);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js + 1 modules
var dist_index_esm = __webpack_require__(639);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(2494);
;// CONCATENATED MODULE: ./src/icons/StarFilledIcon.tsx




var StarFilledIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_dist_index_esm/* Icon */.JO, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M8.87045756,0.52728472 C8.70986869,0.205055169 8.37051109,0 7.99782373,0 \n        C7.62513636,0 7.28880874,0.205055169 7.1251899,0.52728472 L5.17691367,4.40282742 \n        L0.825864437,5.02385164 C0.462267008,5.07658011 0.159269151,5.32264632 \n        0.0471599434,5.65952267 C-0.0649492639,5.99639902 0.0259500934,6.36842768 \n        0.286528251,6.61742324 L3.44376593,9.63759295 L2.6983912,13.9056698 \n        C2.63779163,14.257193 2.78929055,14.6145748 3.08925843,14.8225594 \n        C3.38922631,15.0305439 3.78615351,15.0569081 4.11339119,14.8899346 \n        L8.00085371,12.8833233 L11.8883162,14.8899346 C12.2155539,15.0569081 \n        12.6124811,15.0334733 12.912449,14.8225594 C13.2124169,14.6116455 \n        13.3639158,14.257193 13.3033162,13.9056698 L12.5549115,9.63759295 \n        L15.7121492,6.61742324 C15.9727273,6.36842768 16.0666567,5.99639902 \n        15.9515175,5.65952267 C15.8363783,5.32264632 15.5364104,5.07658011 \n        15.172813,5.02385164 L10.8187338,4.40282742 L8.87045756,0.52728472 Z"
        })
    }));
};
/* harmony default export */ var icons_StarFilledIcon = (StarFilledIcon);

// EXTERNAL MODULE: ./src/icons/StarOutlineIcon.tsx
var StarOutlineIcon = __webpack_require__(12);
;// CONCATENATED MODULE: ./src/components/StarBadge.tsx







var StarBadge = function(_param) {
    var isStarred = _param.isStarred, isSignedIn = _param.isSignedIn, isTooltipDisabled = _param.isTooltipDisabled, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isStarred",
        "isSignedIn",
        "isTooltipDisabled"
    ]);
    var tooltip = "You must be signed in to star a repository";
    if (isSignedIn) {
        tooltip = isStarred ? "Starred" : "Star";
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Tooltip */.u, {
        label: tooltip,
        placement: "bottom",
        isDisabled: isTooltipDisabled,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* Flex */.kC, {
                width: "25px",
                height: "25px",
                alignItems: "center",
                justifyContent: "center",
                children: isStarred ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_StarFilledIcon, {
                    color: "yellow.0",
                    width: "16px",
                    height: "16px",
                    name: "starFilled",
                    role: "StarBadge"
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarOutlineIcon/* default */.Z, {
                    color: "grey.1",
                    width: "16px",
                    height: "16px",
                    name: "starOutline",
                    role: "StarBadge"
                })
            })
        }))
    });
};
/* harmony default export */ var components_StarBadge = (StarBadge);


/***/ }),

/***/ 12:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2494);




var StarOutlineIcon = function(props) {
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Icon */ .JO, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, props), {
        viewBox: "0 0 16 16",
        children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)("path", {
            fill: "currentColor",
            d: "M7.99782373,0 C8.37051109,0 8.70986869,0.205055169 8.87045756,0.52728472 L10.8187338,4.40282742 L15.172813,5.02385164 \n        C15.5364104,5.07658011 15.8363783,5.32264632 15.9515175,5.65952267 C16.0666567,5.99639902 15.9727273,6.36842768 \n        15.7121492,6.61742324 L12.5549115,9.63759295 L13.3033162,13.9056698 C13.3639158,14.257193 13.2124169,14.6116455 12.912449,14.8225594 \n        C12.6124811,15.0334733 12.2155539,15.0569081 11.8883162,14.8899346 L8.00085371,12.8833233 L4.11339119,14.8899346 C3.78615351,15.0569081 \n        3.38922631,15.0305439 3.08925843,14.8225594 C2.78929055,14.6145748 2.63779163,14.257193 2.6983912,13.9056698 L3.44376593,9.63759295 \n        L0.286528251,6.61742324 C0.0259500934,6.36842768 -0.0649492639,5.99639902 0.0471599434,5.65952267 C0.159269151,5.32264632 0.462267008,5.07658011 \n        0.825864437,5.02385164 L5.17691367,4.40282742 L7.1251899,0.52728472 C7.28880874,0.205055169 7.62513636,0 7.99782373,0 Z M10.1600547,5.31900024 \n        L7.997,1.017 L5.83562057,5.31894487 L1.084,5.997 L4.52067138,9.28388991 L3.7,13.977 L8.00085371,11.7579626 L12.3,13.978 L11.4776862,9.28419585 \n        L14.914,5.996 L10.1600547,5.31900024 Z"
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (StarOutlineIcon);


/***/ }),

/***/ 7200:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _layout; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(253);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js + 1 modules
var index_esm = __webpack_require__(639);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/modal/dist/index.esm.js + 60 modules
var dist_index_esm = __webpack_require__(2981);
// EXTERNAL MODULE: ./node_modules/capital-case/dist.es2015/index.js + 4 modules
var dist_es2015 = __webpack_require__(6746);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./src/components/Notification.tsx
var Notification = __webpack_require__(6828);
// EXTERNAL MODULE: ./src/components/PackageIcon.tsx
var PackageIcon = __webpack_require__(4318);
// EXTERNAL MODULE: ./src/components/PageTemplate.tsx + 44 modules
var PageTemplate = __webpack_require__(9220);
// EXTERNAL MODULE: ./src/components/PrismHighlighter.tsx
var PrismHighlighter = __webpack_require__(8805);
// EXTERNAL MODULE: ./src/components/RouteLink.tsx
var RouteLink = __webpack_require__(3600);
// EXTERNAL MODULE: ./src/components/TabGroup.tsx
var TabGroup = __webpack_require__(2934);
// EXTERNAL MODULE: ./src/contexts/accounts.tsx
var contexts_accounts = __webpack_require__(8054);
// EXTERNAL MODULE: ./src/contexts/currentUser.tsx
var contexts_currentUser = __webpack_require__(8811);
// EXTERNAL MODULE: ./src/graphql/upbound-graphql.tsx + 18 modules
var upbound_graphql = __webpack_require__(5107);
// EXTERNAL MODULE: ./src/utils/constants/config.ts
var config = __webpack_require__(5581);
// EXTERNAL MODULE: ./src/utils/constants/urls.ts
var urls = __webpack_require__(6549);
// EXTERNAL MODULE: ./src/utils/helpers/routing.ts + 1 modules
var routing = __webpack_require__(949);
// EXTERNAL MODULE: ./src/utils/hooks/usePageScrollPadding.ts
var usePageScrollPadding = __webpack_require__(9432);
;// CONCATENATED MODULE: ./src/utils/hooks/usePageScrollTo.ts


function usePageScrollTo() {
    var isDisabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var routerRef = (0,react.useRef)((0,next_router.useRouter)());
    var scrollRef = (0,react.useRef)(null);
    (0,react.useEffect)(function() {
        if (!scrollRef.current || isDisabled) {
            return;
        }
        var scrollPaddingTopWithoutPx = document.documentElement.style.scrollPaddingTop.replace("px", "");
        var scrollPaddingTop = parseInt(scrollPaddingTopWithoutPx, 10);
        var top = scrollRef.current.offsetTop - scrollPaddingTop;
        var handleRouteChangeStop = function() {
            document.documentElement.style.scrollBehavior = "smooth";
            window.scrollTo({
                top: top
            });
        };
        var router = routerRef.current;
        router.events.on("routeChangeComplete", handleRouteChangeStop);
        handleRouteChangeStop();
        return function() {
            router.events.off("routeChangeComplete", handleRouteChangeStop);
        };
    }, [
        isDisabled
    ]);
    return [
        scrollRef
    ];
}
/* harmony default export */ var hooks_usePageScrollTo = (usePageScrollTo);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/button/dist/index.esm.js
var button_dist_index_esm = __webpack_require__(7741);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/tooltip/dist/index.esm.js
var tooltip_dist_index_esm = __webpack_require__(7026);
// EXTERNAL MODULE: ./src/components/StarBadge.tsx + 1 modules
var StarBadge = __webpack_require__(6290);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/icon/dist/index.esm.js
var icon_dist_index_esm = __webpack_require__(2494);
;// CONCATENATED MODULE: ./src/icons/UpboundOfficialIcon.tsx




var UpboundOfficialIcon = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icon_dist_index_esm/* Icon */.JO, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        viewBox: "0 0 164 21",
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fill: "currentColor",
            d: "M100.13 6.231C103.522 6.168 105.964 8.681 105.937 11.843 105.906 15.433 103.303 17.351 100.13 17.426 96.869 17.503 94.269 14.991 94.334 11.843 94.403 8.498 97.18 6.285 100.13 6.231ZM100.13 8.885C98.332 8.804 97.632 10.304 97.572 11.843 97.503 13.611 98.56 14.688 100.13 14.762 101.923 14.847 102.639 13.372 102.699 11.843 102.768 10.068 101.707 8.955 100.13 8.885ZM124.624 15.686V7.961C124.624 7.722 124.767 7.099 125.063 6.801 125.36 6.503 125.839 6.349 126.238 6.349 126.637 6.349 126.827 6.421 127.072 6.555 127.317 6.69 127.515 6.88 127.654 7.125 127.793 7.371 127.862 7.804 127.862 7.961V15.686C127.862 15.844 127.793 16.286 127.654 16.532 127.515 16.777 127.321 16.967 127.072 17.102 126.823 17.236 126.633 17.298 126.238 17.298S125.36 17.154 125.063 16.856C124.767 16.558 124.624 15.925 124.624 15.686ZM126.238 2.005C126.637 2.005 126.86 2.08 127.138 2.231 127.416 2.381 127.639 2.584 127.807 2.83 127.976 3.076 128.06 3.236 128.06 3.597 128.06 3.957 127.877 4.445 127.522 4.776 127.167 5.107 126.728 5.268 126.238 5.268 125.747 5.268 125.334 5.097 124.964 4.757 124.595 4.416 124.415 4.019 124.415 3.597 124.415 3.174 124.595 2.82 124.964 2.496 125.334 2.172 125.839 2.005 126.238 2.005ZM108.304 15.686V9.012C107.059 9.128 106.217 8.794 106.163 7.735 106.101 6.52 107.25 6.467 108.304 6.467V4.983C108.304 3.934 108.613 3.12 109.237 2.545 109.865 1.967 110.686 1.68 111.696 1.68 112.34 1.68 112.873 1.783 113.299 1.985 113.73 2.189 113.946 2.522 113.946 2.987 113.946 3.806 113.503 4.216 112.618 4.216 112.259 4.216 111.989 4.275 111.806 4.393 111.623 4.511 111.531 4.809 111.531 5.287V6.467H112.552C113.643 6.467 114.188 6.889 114.188 7.735 114.188 8.587 113.643 9.012 112.552 9.012H111.531V15.686C111.531 16.165 111.381 16.554 111.081 16.856 110.788 17.151 110.4 17.298 109.917 17.298S109.039 17.154 108.743 16.856C108.447 16.558 108.304 16.165 108.304 15.686ZM117.053 15.686V9.012H116.328C115.904 9.012 115.563 8.898 115.307 8.668 115.044 8.433 114.912 8.121 114.912 7.735 114.912 7.374 115.047 7.073 115.318 6.83 115.589 6.588 115.926 6.467 116.328 6.467H117.053V4.983C117.053 3.934 117.362 3.12 117.986 2.545 118.613 1.967 119.435 1.68 120.445 1.68 121.089 1.68 121.622 1.783 122.047 1.985 122.479 2.189 122.695 2.522 122.695 2.987 122.695 3.806 122.252 4.216 121.367 4.216 121.008 4.216 120.737 4.275 120.554 4.393 120.372 4.511 120.28 4.809 120.28 5.287V6.467H121.301C122.391 6.467 122.937 6.889 122.937 7.735 122.937 8.587 122.391 9.012 121.301 9.012H120.28V15.686C120.28 16.165 120.13 16.554 119.83 16.856 119.537 17.151 119.149 17.298 118.666 17.298 118.183 17.298 117.788 17.154 117.492 16.856 117.196 16.558 117.053 16.165 117.053 15.686ZM141.194 15.686V7.961C141.194 7.482 141.34 7.096 141.633 6.801 141.933 6.499 142.325 6.349 142.808 6.349 143.123 6.349 143.398 6.422 143.642 6.555 143.889 6.69 144.084 6.877 144.224 7.125 144.362 7.369 144.433 7.646 144.433 7.961V15.686C144.433 16.001 144.364 16.283 144.224 16.532 144.086 16.775 143.892 16.967 143.642 17.102 143.395 17.235 143.115 17.298 142.808 17.298 142.325 17.298 141.93 17.154 141.633 16.856 141.337 16.558 141.194 16.165 141.194 15.686ZM142.808 2.005C143.13 2.005 143.43 2.08 143.708 2.231 143.986 2.381 144.208 2.582 144.378 2.83 144.544 3.074 144.63 3.328 144.63 3.597 144.63 4.049 144.451 4.442 144.092 4.776 143.741 5.104 143.313 5.268 142.808 5.268 142.332 5.268 141.906 5.099 141.535 4.757 141.167 4.418 140.986 4.029 140.986 3.597 140.986 3.184 141.169 2.817 141.535 2.496 141.908 2.168 142.332 2.005 142.808 2.005ZM157.853 8.246V15.411C157.853 15.975 157.766 16.43 157.59 16.777 157.414 17.125 156.982 17.298 156.295 17.298 155.855 17.298 155.512 17.2 155.274 16.993 155.036 16.787 155.123 15.877 154.747 16.07 153.638 16.637 152.862 17.426 151.662 17.426 150.667 17.426 149.759 17.187 148.94 16.708 148.12 16.23 147.472 15.571 147.008 14.723 146.542 13.873 146.316 12.911 146.316 11.843 146.316 10.814 146.555 9.872 147.03 9.012 147.507 8.148 148.154 7.472 148.973 6.978 149.794 6.482 150.689 6.231 151.662 6.231 152.27 6.231 152.848 6.342 153.397 6.565 153.945 6.788 154.197 7.439 154.747 7.558 155.095 7.633 154.959 6.916 155.252 6.693 155.552 6.464 155.899 6.349 156.295 6.349 156.982 6.349 157.413 6.526 157.59 6.88 157.764 7.228 157.853 7.682 157.853 8.246ZM149.554 11.843C149.554 12.335 149.645 12.808 149.84 13.259 150.033 13.706 150.324 14.072 150.707 14.35 151.092 14.629 151.563 14.762 152.112 14.762 152.903 14.762 153.519 14.472 153.956 13.888 154.397 13.299 154.615 12.616 154.615 11.843 154.615 11.358 154.516 10.892 154.33 10.438 154.142 9.981 153.86 9.607 153.473 9.317 153.091 9.031 152.639 8.885 152.112 8.885 151.571 8.885 151.103 9.029 150.707 9.317 150.319 9.599 150.03 9.969 149.84 10.428 149.65 10.887 149.554 11.358 149.554 11.843ZM159.899 15.686V3.292C159.899 2.814 160.045 2.427 160.338 2.132 160.638 1.831 161.029 1.68 161.512 1.68 161.827 1.68 162.103 1.753 162.347 1.887 162.593 2.022 162.788 2.208 162.929 2.457 163.066 2.7 163.137 2.978 163.137 3.292V15.686C163.137 16.001 163.069 16.283 162.929 16.532 162.791 16.775 162.597 16.967 162.347 17.102 162.099 17.235 161.82 17.298 161.512 17.298 161.029 17.298 160.634 17.154 160.338 16.856 160.042 16.558 159.899 16.165 159.899 15.686ZM139.273 8.059C139.273 8.387 139.156 8.701 138.922 9.003 138.688 9.304 138.391 9.455 138.033 9.455 137.799 9.455 137.407 9.361 136.858 9.17 136.316 8.981 135.856 8.885 135.475 8.885 134.897 8.885 134.4 9.026 133.982 9.307 133.573 9.583 133.265 9.946 133.06 10.398 132.855 10.85 132.753 11.332 132.753 11.843 132.753 12.616 132.996 13.299 133.488 13.888 133.977 14.472 134.641 14.762 135.475 14.762 135.702 14.762 135.948 14.729 136.21 14.654 136.475 14.579 136.792 14.473 137.165 14.35 137.546 14.224 137.784 14.163 137.879 14.163 138.128 14.163 138.357 14.224 138.571 14.34 138.781 14.454 138.947 14.608 139.076 14.802 139.203 14.994 139.273 15.201 139.273 15.431 139.273 15.883 139.038 16.258 138.571 16.561 138.108 16.861 137.564 17.082 136.935 17.22 136.306 17.357 135.764 17.426 135.31 17.426 134.191 17.426 133.187 17.179 132.302 16.679 131.416 16.177 130.725 15.499 130.239 14.644 129.752 13.788 129.514 12.852 129.514 11.843 129.514 11.122 129.651 10.424 129.931 9.75 130.215 9.067 130.619 8.462 131.139 7.931 131.658 7.401 132.277 6.984 132.994 6.683 133.711 6.382 134.483 6.231 135.31 6.231 135.808 6.231 136.367 6.297 136.99 6.418 137.618 6.539 138.156 6.735 138.604 7.007 139.048 7.278 139.273 7.627 139.273 8.059ZM62.069 7.973 62.027 12.507C62.027 16.633 58.086 17.469 56.715 17.469 53.864 17.469 51.455 15.718 51.455 12.507V7.973C51.455 6.969 52.03 6.368 52.959 6.368 53.909 6.368 54.485 6.969 54.485 7.973V12.164C54.485 13.79 55.3 14.682 56.715 14.682 58.219 14.682 59.039 13.924 59.039 12.164V7.973C59.039 6.969 59.615 6.368 60.566 6.368 61.494 6.368 62.069 6.969 62.069 7.973M12.123 8.173 12.08 12.707C12.08 16.831 8.14 17.668 6.769 17.668 3.917 17.668 1.51 15.917 1.51 12.707V8.173C1.51 7.169 2.084 6.566 3.014 6.566 3.963 6.566 4.539 7.169 4.539 8.173V12.364C4.539 13.99 5.355 14.881 6.769 14.881 8.273 14.881 9.094 14.124 9.094 12.364V8.173C9.094 7.169 9.668 6.566 10.62 6.566 11.548 6.566 12.123 7.169 12.123 8.173M34.272 11.852C34.272 10.157 33.188 9.021 31.641 9.021 30.07 9.021 28.943 10.202 28.943 11.852 28.943 13.5 30.07 14.682 31.641 14.682 33.188 14.682 34.272 13.522 34.272 11.852M37.368 11.852C37.368 15.262 35.333 17.469 32.259 17.469 30.845 17.469 29.717 16.978 28.965 16.087H28.922C28.789 16.866 28.236 17.335 27.439 17.335 26.489 17.335 25.914 16.71 25.914 15.708V3.091C25.914 2.088 26.489 1.464 27.439 1.464 28.369 1.464 28.943 2.088 28.943 3.091V7.594H28.988C29.717 6.724 30.845 6.234 32.259 6.234 35.333 6.234 37.368 8.441 37.368 11.852M44.4 14.682C45.993 14.682 47.077 13.522 47.077 11.852 47.077 10.157 45.993 9.021 44.4 9.021 42.83 9.021 41.747 10.157 41.747 11.852 41.747 13.522 42.83 14.682 44.4 14.682M44.4 6.234C47.827 6.234 50.172 8.508 50.172 11.852 50.172 15.172 47.827 17.469 44.4 17.469 40.995 17.469 38.651 15.172 38.651 11.852 38.651 8.508 40.995 6.234 44.4 6.234M74.069 11.212V15.737C74.069 16.74 73.495 17.365 72.544 17.365 71.616 17.365 71.04 16.74 71.04 15.737V11.569C71.04 9.919 70.289 9.049 68.828 9.049 67.303 9.049 66.419 10.096 66.419 11.858V15.737C66.419 16.74 65.844 17.365 64.893 17.365 63.965 17.365 63.389 16.74 63.389 15.737V8.024C63.389 7.021 63.965 6.396 64.893 6.396 65.689 6.396 66.243 6.843 66.396 7.6H66.44C67.171 6.73 68.232 6.262 69.626 6.262 72.522 6.262 74.069 8.001 74.069 11.212M83.777 11.88C83.777 10.23 82.65 9.049 81.079 9.049 79.532 9.049 78.449 10.186 78.449 11.88 78.449 13.552 79.532 14.711 81.079 14.711 82.65 14.711 83.777 13.53 83.777 11.88M86.807 3.119V15.737C86.807 16.74 86.232 17.365 85.281 17.365 84.485 17.365 83.932 16.896 83.8 16.115H83.756C83.004 17.008 81.876 17.497 80.461 17.497 77.386 17.497 75.353 15.291 75.353 11.88S77.386 6.262 80.461 6.262C81.876 6.262 83.004 6.754 83.733 7.623H83.777V3.119C83.777 2.117 84.352 1.493 85.281 1.493 86.232 1.493 86.807 2.117 86.807 3.119M21.537 11.788C21.537 10.165 20.498 9.076 19.015 9.076 17.511 9.076 16.43 10.207 16.43 11.788 16.43 13.369 17.511 14.501 19.015 14.501 20.498 14.501 21.537 13.391 21.537 11.788M24.504 11.788C24.504 15.056 22.554 17.172 19.609 17.172 18.274 17.172 17.192 16.701 16.473 15.889H16.43V19.457C16.43 20.419 15.878 21.016 14.968 21.016 14.077 21.016 13.526 20.419 13.526 19.457V8.071C13.526 7.111 14.077 6.533 14.968 6.533 15.751 6.533 16.281 6.96 16.409 7.708H16.451C17.172 6.876 18.252 6.405 19.609 6.405 22.554 6.405 24.504 8.52 24.504 11.788M5.262 2.2C5.262 3.424 4.278 4.417 3.062 4.417 1.848 4.417.863 3.424.863 2.2.863 .976 1.848-.016 3.062-.016 4.278-.016 5.262.976 5.262 2.2"
        })
    }));
};
/* harmony default export */ var icons_UpboundOfficialIcon = (UpboundOfficialIcon);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/PackageLegal.tsx



var PackageLegal = function(param) {
    var data = param.data;
    if (!data.official) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                as: "span",
                display: "block",
                fontSize: "14px",
                lineHeight: "20px",
                color: "black.0",
                fontWeight: 900,
                mb: "8px",
                children: "Legal Notices"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Link */.rU, {
                color: "purple.0",
                _hover: {
                    textDecoration: "underline"
                },
                href: "".concat(urls/* UPBOUND_LICENSES_URL */.gI, "/notice-").concat(data.name, ".html"),
                target: "_blank",
                rel: "noopener noreferrer",
                children: "View"
            })
        ]
    });
};
/* harmony default export */ var _components_PackageLegal = (PackageLegal);

// EXTERNAL MODULE: ./src/icons/ChevronIcon.tsx
var ChevronIcon = __webpack_require__(1627);
;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/PackageListBreadcrumbs.tsx



var PackageListBreadcrumbs = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronIcon/* default */.Z, {
                direction: "right",
                size: "lg",
                color: "white.5",
                width: "16px",
                height: "16px",
                mr: "6px",
                ml: "6px"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                as: "span",
                color: "grey.1",
                fontSize: "14px",
                lineHeight: "40px",
                children: data.displayName
            })
        ]
    });
};
/* harmony default export */ var _components_PackageListBreadcrumbs = (PackageListBreadcrumbs);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/PackageListLink.tsx






var PackageListLink = function(_param) {
    var data = _param.data, props = (0,_object_without_properties/* default */.Z)(_param, [
        "data"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RouteLink/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        to: "packageList",
        params: {
            packageType: data.packageType
        },
        display: "block",
        color: "purple.0",
        prefetch: false,
        _hover: {
            textDecoration: "underline"
        },
        fontSize: "14px",
        lineHeight: "40px"
    }, props), {
        children: (0,dist_es2015/* capitalCase */.I)("".concat(data.packageType, "S"))
    }));
};
/* harmony default export */ var _components_PackageListLink = (PackageListLink);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/PackageMaintainer.tsx


var PackageMaintainer = function(param) {
    var data = param.data;
    var ref;
    if (data.official && !data.maintainer) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
        mr: {
            base: "0",
            xl: "65px"
        },
        mb: {
            base: "20px",
            xl: "0"
        },
        pb: {
            base: "20px",
            xl: "0"
        },
        borderBottom: {
            base: "1px solid",
            xl: "none"
        },
        borderBottomColor: {
            base: "white.4",
            xl: "none"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                as: "span",
                display: "block",
                fontSize: "14px",
                lineHeight: "20px",
                color: "black.0",
                fontWeight: 900,
                mb: "8px",
                children: "Support"
            }),
            data.official ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Link */.rU, {
                color: "purple.0",
                _hover: {
                    textDecoration: "underline"
                },
                href: "mailto:".concat(data.maintainer),
                children: (ref = data.maintainer) === null || ref === void 0 ? void 0 : ref.replace(/ <.+>$/, "")
            }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                children: "None"
            })
        ]
    });
};
/* harmony default export */ var _components_PackageMaintainer = (PackageMaintainer);

// EXTERNAL MODULE: ./src/components/Markdown.tsx + 3 modules
var Markdown = __webpack_require__(8253);
;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/PackageOverview.tsx







var OverviewText = function() {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
        as: "span",
        fontWeight: 900,
        color: "black.0",
        fontSize: "20px",
        lineHeight: "25px",
        mb: "20px",
        display: "inline-block",
        children: "Overview"
    });
};
var OverviewLink = function(props) {
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Link */.rU, (0,_object_spread/* default */.Z)({
        color: "purple.0",
        display: "inline-block",
        mt: "15px",
        fontSize: "14px",
        lineHeight: "20px",
        _hover: {
            textDecoration: "underline"
        }
    }, props));
};
var Overview = function(param) {
    var readme = param.readme, setState = param.setState;
    var markdownRef = (0,react.useRef)(null);
    var ref = (0,react.useState)(false), showOverviewLink = ref[0], setShowOverviewLink = ref[1];
    var isTruncated = function() {
        if (!markdownRef.current) {
            return;
        }
        var truncated = markdownRef.current.clientHeight < markdownRef.current.scrollHeight;
        setShowOverviewLink(truncated);
    };
    // compare once and add resize listener on "componentDidMount"
    // remove the listener on unmount
    (0,react.useEffect)(function() {
        isTruncated();
        window.addEventListener("resize", isTruncated);
        return function() {
            window.removeEventListener("resize", isTruncated);
        };
    }, []);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Markdown/* default */.Z, {
                ref: markdownRef,
                noOfLines: 3,
                maxHeight: "90px",
                textOverflow: "ellipsis",
                overflow: "hidden",
                whiteSpace: "nowrap",
                children: readme
            }),
            showOverviewLink && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverviewLink, {
                onClick: function() {
                    return setState({
                        isOpen: true
                    });
                },
                children: "Show Full Overview"
            })
        ]
    });
};
var PackageOverview = function(_param) {
    var data = _param.data, props = (0,_object_without_properties/* default */.Z)(_param, [
        "data"
    ]);
    var ref = (0,react.useState)({
        isOpen: false
    }), isOpen = ref[0].isOpen, setState = ref[1];
    var readme = data.readme || "";
    if (readme) {
        if (!isOpen) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverviewText, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Overview, {
                        setState: setState,
                        readme: readme
                    })
                ]
            }));
        }
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverviewText, {}),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Markdown/* default */.Z, {
                    children: readme
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverviewLink, {
                    onClick: function() {
                        return setState({
                            isOpen: false
                        });
                    },
                    children: "Hide Full Overview"
                })
            ]
        }));
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OverviewText, {}),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                lineHeight: "25px",
                fontSize: "14px",
                color: "grey.0",
                fontStyle: "oblique",
                children: "No overview provided."
            })
        ]
    }));
};
/* harmony default export */ var _components_PackageOverview = (PackageOverview);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/PackageSource.tsx


var PackageSource = function(param) {
    var data = param.data;
    if (!data.source) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
        mr: {
            base: "0",
            xl: "65px"
        },
        mb: {
            base: "20px",
            xl: "0"
        },
        pb: {
            base: "20px",
            xl: "0"
        },
        borderBottom: {
            base: "1px solid",
            xl: "none"
        },
        borderBottomColor: {
            base: "white.4",
            xl: "none"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                as: "span",
                display: "block",
                fontSize: "14px",
                lineHeight: "20px",
                color: "black.0",
                fontWeight: 900,
                mb: "8px",
                children: "Source Code"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Link */.rU, {
                color: "purple.0",
                _hover: {
                    textDecoration: "underline"
                },
                href: "https://".concat(data.source),
                target: "_blank",
                rel: "noopener noreferrer",
                children: data.source
            })
        ]
    });
};
/* harmony default export */ var _components_PackageSource = (PackageSource);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/PackageType.tsx



var PackageType = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
        mr: {
            base: "0",
            xl: "65px"
        },
        mb: {
            base: "20px",
            xl: "0"
        },
        pb: {
            base: "20px",
            xl: "0"
        },
        borderBottom: {
            base: "1px solid",
            xl: "none"
        },
        borderBottomColor: {
            base: "white.4",
            xl: "none"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                display: "block",
                fontSize: "14px",
                lineHeight: "20px",
                color: "black.0",
                fontWeight: 900,
                mb: "8px",
                children: "Package Type"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                children: (0,dist_es2015/* capitalCase */.I)(data.packageType)
            })
        ]
    });
};
/* harmony default export */ var _components_PackageType = (PackageType);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/menu/dist/index.esm.js + 1 modules
var menu_dist_index_esm = __webpack_require__(9052);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/portal/dist/index.esm.js
var portal_dist_index_esm = __webpack_require__(7174);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/utils/constants/routes.ts


var ROUTE_ROOT_INDEX = {
    pathname: "/",
    query: {}
};
var ROUTE_PACKAGE_LIST = {
    pathname: "/[packageType]",
    query: {
        packageType: ""
    }
};
var ROUTE_PACKAGE_DETAILS = {
    pathname: ROUTE_PACKAGE_LIST.pathname + "/[packageAccount]/[packageName]/[packageVersion]",
    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ROUTE_PACKAGE_LIST.query), {
        packageAccount: "",
        packageName: "",
        packageVersion: ""
    })
};
var ROUTE_COMPOSITION_DETAILS = {
    pathname: ROUTE_PACKAGE_DETAILS.pathname + "/compositions/[compositionName]",
    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ROUTE_PACKAGE_DETAILS.query), {
        compositionName: ""
    })
};
var ROUTE_RESOURCE_DETAILS = {
    pathname: ROUTE_PACKAGE_DETAILS.pathname + "/resources/[resourceGroup]/[resourceKind]/[resourceVersion]",
    query: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ROUTE_PACKAGE_DETAILS.query), {
        resourceGroup: "",
        resourceKind: "",
        resourceVersion: ""
    })
};


;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/PackageVersionMenu.tsx








var PackageVersionMenu = function(param) {
    var data = param.data;
    if (!data || !data.versions || data.versions.length < 2) {
        return null;
    }
    var _versions = (0,_sliced_to_array/* default */.Z)(data.versions, 1), firstVersion = _versions[0];
    var selectedVersion = data.version || firstVersion;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(menu_dist_index_esm/* Menu */.v2, {
        placement: "bottom-end",
        gutter: 0,
        matchWidth: true,
        isLazy: true,
        preventOverflow: false,
        flip: false,
        eventListeners: {
            resize: true,
            scroll: false
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(menu_dist_index_esm/* MenuButton */.j2, {
                width: "100%",
                className: "listing-version-dropdown",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                        as: "span",
                        children: selectedVersion
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronIcon/* default */.Z, {
                        direction: "down",
                        size: "sm"
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(portal_dist_index_esm/* Portal */.h_, {
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(menu_dist_index_esm/* MenuList */.qy, {
                    width: "100%",
                    children: data.versions.map(function(version) {
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)((link_default()), {
                            href: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, ROUTE_PACKAGE_DETAILS), {
                                query: {
                                    packageType: data.packageType.toLowerCase() + "s",
                                    packageAccount: data.account,
                                    packageName: data.name,
                                    packageVersion: version
                                }
                            }),
                            passHref: true,
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(menu_dist_index_esm/* MenuItem */.sN, {
                                as: index_esm/* Link */.rU,
                                width: "100%",
                                children: version
                            })
                        }, version);
                    })
                })
            })
        ]
    });
};
/* harmony default export */ var _components_PackageVersionMenu = (PackageVersionMenu);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/FamilyProviderHeader.tsx














var FamilyProviderHeader = function(param) {
    var data = param.data, setIsInstallModalVisible = param.setIsInstallModalVisible, onStarClick = param.onStarClick, isStarred = param.isStarred;
    var currentUser = (0,contexts_currentUser/* useCurrentUser */.x)().currentUser;
    var tooltip = "You must be signed in to star a repository";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
        flexDirection: {
            base: "column",
            lg: "row"
        },
        width: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageListLink, {
                display: {
                    base: "inline",
                    lg: "none"
                },
                mb: "25px",
                data: data
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                flexDirection: "column",
                alignItems: "center",
                mr: {
                    base: "0",
                    lg: "125px"
                },
                minWidth: "265px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        p: "0 20px",
                        mb: "30px",
                        height: "253px",
                        width: "100%",
                        border: "1px solid",
                        borderRadius: "20px",
                        borderColor: "white.5",
                        backgroundColor: "white.0",
                        position: "relative",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        boxShadow: "0 3px 10px 0 rgba(0, 0, 0, 0.03)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PackageIcon/* default */.Z, {
                                data: data,
                                width: "64px",
                                height: "64px",
                                m: "auto auto 20px auto"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
                                mb: "auto",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Heading */.X6, {
                                        as: "h3",
                                        size: "md",
                                        fontSize: "20px",
                                        lineHeight: "25px",
                                        noOfLines: 2,
                                        width: "100%",
                                        children: [
                                            data.displayName,
                                            " (Family)"
                                        ]
                                    }),
                                    data.official ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                                        mt: "30px",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_UpboundOfficialIcon, {
                                            role: "UpboundOfficialIcon",
                                            color: "purple.6",
                                            width: "110px"
                                        })
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Text */.xv, {
                                        size: "sm",
                                        noOfLines: 1,
                                        mt: "30px",
                                        children: [
                                            data.account,
                                            "/",
                                            data.name
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(button_dist_index_esm/* Button */.zx, {
                        variant: "blackOutline",
                        size: "md",
                        width: "100%",
                        fontWeight: 900,
                        onClick: function() {
                            return setIsInstallModalVisible(true);
                        },
                        children: "Install Manifest"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        justifyContent: "center",
                        display: {
                            base: "block",
                            xl: "none"
                        },
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tooltip_dist_index_esm/* Tooltip */.u, {
                                label: tooltip,
                                placement: "bottom",
                                isDisabled: !!currentUser,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                                    onClick: function(e) {
                                        e.preventDefault();
                                        onStarClick();
                                    },
                                    mt: {
                                        base: "20px",
                                        xl: "0"
                                    },
                                    px: "15px",
                                    py: "5px",
                                    cursor: "pointer",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "white.0",
                                    _hover: {
                                        border: "1px solid",
                                        borderColor: "black.0"
                                    },
                                    border: "1px solid",
                                    borderColor: "white.5",
                                    borderRadius: "5px",
                                    minWidth: "110px",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                            mr: "6px",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarBadge/* default */.Z, {
                                                isTooltipDisabled: true,
                                                isSignedIn: !!currentUser,
                                                isStarred: isStarred
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                            as: "span",
                                            color: "grey.0",
                                            fontSize: "14px",
                                            children: isStarred ? "Starred" : "Star"
                                        })
                                    ]
                                })
                            }),
                            data && data.versions && data.versions.length >= 2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                display: {
                                    base: "block",
                                    xl: "none"
                                },
                                position: "relative",
                                width: {
                                    base: "100%",
                                    xl: "130px"
                                },
                                mt: {
                                    base: "20px",
                                    xl: "0"
                                },
                                mb: {
                                    base: "50px",
                                    xl: "0"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageVersionMenu, {
                                    data: data
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                flexDirection: "column",
                width: "100%",
                flexShrink: 1,
                flexGrow: 0,
                overflow: "auto",
                minHeight: "326.5px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                                display: {
                                    base: "none",
                                    lg: "flex"
                                },
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageListLink, {
                                        data: data
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageListBreadcrumbs, {
                                        data: data
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                                display: {
                                    base: "none",
                                    xl: "flex"
                                },
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tooltip_dist_index_esm/* Tooltip */.u, {
                                        label: tooltip,
                                        placement: "bottom",
                                        isDisabled: !!currentUser,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                                            onClick: function(e) {
                                                e.preventDefault();
                                                onStarClick();
                                            },
                                            mr: "10px",
                                            px: "15px",
                                            py: "5px",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: "white.0",
                                            _hover: {
                                                border: "1px solid",
                                                borderColor: "black.0"
                                            },
                                            cursor: "pointer",
                                            border: "1px solid",
                                            borderColor: "white.5",
                                            borderRadius: "5px",
                                            minWidth: "110px",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                                    mr: "6px",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarBadge/* default */.Z, {
                                                        isTooltipDisabled: true,
                                                        isSignedIn: !!currentUser,
                                                        isStarred: isStarred
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                                    as: "span",
                                                    color: "grey.0",
                                                    fontSize: "14px",
                                                    children: isStarred ? "Starred" : "Star"
                                                })
                                            ]
                                        })
                                    }),
                                    data && data.versions && data.versions.length >= 2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                        width: {
                                            base: "100%",
                                            xl: "130px"
                                        },
                                        position: "relative",
                                        ml: {
                                            base: "0",
                                            md: "auto"
                                        },
                                        maxWidth: "100%",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageVersionMenu, {
                                            data: data
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageOverview, {
                        data: data,
                        mb: {
                            base: "50px",
                            md: "39px"
                        },
                        mt: "39px"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        flexDirection: {
                            base: "column",
                            xl: "row"
                        },
                        justifyContent: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageType, {
                                data: data
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageMaintainer, {
                                data: data
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageSource, {
                                data: data
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageLegal, {
                                data: data
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var _components_FamilyProviderHeader = (FamilyProviderHeader);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/PackageHeader.tsx














var PackageHeader = function(param) {
    var data = param.data, setIsInstallModalVisible = param.setIsInstallModalVisible, onStarClick = param.onStarClick, isStarred = param.isStarred;
    var currentUser = (0,contexts_currentUser/* useCurrentUser */.x)().currentUser;
    var tooltip = "You must be signed in to star a repository";
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
        flexDirection: {
            base: "column",
            lg: "row"
        },
        width: "100%",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageListLink, {
                display: {
                    base: "inline",
                    lg: "none"
                },
                mb: "25px",
                data: data
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                flexDirection: "column",
                alignItems: "center",
                mr: {
                    base: "0",
                    lg: "125px"
                },
                minWidth: "265px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        p: "0 20px",
                        mb: "30px",
                        height: "253px",
                        width: "100%",
                        border: "1px solid",
                        borderRadius: "20px",
                        borderColor: "white.5",
                        backgroundColor: "white.0",
                        position: "relative",
                        flexDirection: "column",
                        alignItems: "center",
                        textAlign: "center",
                        boxShadow: "0 3px 10px 0 rgba(0, 0, 0, 0.03)",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PackageIcon/* default */.Z, {
                                data: data,
                                width: "64px",
                                height: "64px",
                                m: "auto auto 20px auto"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
                                mb: "auto",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Heading */.X6, {
                                        as: "h3",
                                        size: "md",
                                        fontSize: "20px",
                                        lineHeight: "25px",
                                        noOfLines: 2,
                                        width: "100%",
                                        children: data.displayName
                                    }),
                                    data.official ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                                        mt: "30px",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(icons_UpboundOfficialIcon, {
                                            role: "UpboundOfficialIcon",
                                            color: "purple.6",
                                            width: "110px"
                                        })
                                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Text */.xv, {
                                        size: "sm",
                                        noOfLines: 1,
                                        mt: "30px",
                                        children: [
                                            data.account,
                                            "/",
                                            data.name
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(button_dist_index_esm/* Button */.zx, {
                        variant: "blackOutline",
                        size: "md",
                        width: "100%",
                        fontWeight: 900,
                        onClick: function() {
                            return setIsInstallModalVisible(true);
                        },
                        children: "Install Manifest"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        justifyContent: "center",
                        display: {
                            base: "block",
                            xl: "none"
                        },
                        alignItems: "center",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tooltip_dist_index_esm/* Tooltip */.u, {
                                label: tooltip,
                                placement: "bottom",
                                isDisabled: !!currentUser,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                                    onClick: function(e) {
                                        e.preventDefault();
                                        onStarClick();
                                    },
                                    mt: {
                                        base: "20px",
                                        xl: "0"
                                    },
                                    px: "15px",
                                    py: "5px",
                                    cursor: "pointer",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    backgroundColor: "white.0",
                                    _hover: {
                                        border: "1px solid",
                                        borderColor: "black.0"
                                    },
                                    border: "1px solid",
                                    borderColor: "white.5",
                                    borderRadius: "5px",
                                    minWidth: "110px",
                                    children: [
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                            mr: "6px",
                                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarBadge/* default */.Z, {
                                                isTooltipDisabled: true,
                                                isSignedIn: !!currentUser,
                                                isStarred: isStarred
                                            })
                                        }),
                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                            as: "span",
                                            color: "grey.0",
                                            fontSize: "14px",
                                            children: isStarred ? "Starred" : "Star"
                                        })
                                    ]
                                })
                            }),
                            data && data.versions && data.versions.length >= 2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                display: {
                                    base: "block",
                                    xl: "none"
                                },
                                position: "relative",
                                width: {
                                    base: "100%",
                                    xl: "130px"
                                },
                                mt: {
                                    base: "20px",
                                    xl: "0"
                                },
                                mb: {
                                    base: "50px",
                                    xl: "0"
                                },
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageVersionMenu, {
                                    data: data
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                flexDirection: "column",
                width: "100%",
                flexShrink: 1,
                flexGrow: 0,
                overflow: "auto",
                minHeight: "326.5px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        justifyContent: "space-between",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                                display: {
                                    base: "none",
                                    lg: "flex"
                                },
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageListLink, {
                                        data: data
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageListBreadcrumbs, {
                                        data: data
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                                display: {
                                    base: "none",
                                    xl: "flex"
                                },
                                alignItems: "center",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(tooltip_dist_index_esm/* Tooltip */.u, {
                                        label: tooltip,
                                        placement: "bottom",
                                        isDisabled: !!currentUser,
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                                            onClick: function(e) {
                                                e.preventDefault();
                                                onStarClick();
                                            },
                                            mr: "10px",
                                            px: "15px",
                                            py: "5px",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            backgroundColor: "white.0",
                                            _hover: {
                                                border: "1px solid",
                                                borderColor: "black.0"
                                            },
                                            cursor: "pointer",
                                            border: "1px solid",
                                            borderColor: "white.5",
                                            borderRadius: "5px",
                                            minWidth: "110px",
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                                    mr: "6px",
                                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StarBadge/* default */.Z, {
                                                        isTooltipDisabled: true,
                                                        isSignedIn: !!currentUser,
                                                        isStarred: isStarred
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                                    as: "span",
                                                    color: "grey.0",
                                                    fontSize: "14px",
                                                    children: isStarred ? "Starred" : "Star"
                                                })
                                            ]
                                        })
                                    }),
                                    data && data.versions && data.versions.length >= 2 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                        width: {
                                            base: "100%",
                                            xl: "130px"
                                        },
                                        position: "relative",
                                        ml: {
                                            base: "0",
                                            md: "auto"
                                        },
                                        maxWidth: "100%",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageVersionMenu, {
                                            data: data
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageOverview, {
                        data: data,
                        mb: {
                            base: "50px",
                            md: "39px"
                        },
                        mt: "39px"
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        flexDirection: {
                            base: "column",
                            xl: "row"
                        },
                        justifyContent: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageType, {
                                data: data
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageMaintainer, {
                                data: data
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageSource, {
                                data: data
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageLegal, {
                                data: data
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var _components_PackageHeader = (PackageHeader);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./src/utils/constants/tabs.ts
var tabs = __webpack_require__(9170);
// EXTERNAL MODULE: ./src/utils/guards/models.ts
var models = __webpack_require__(8834);
// EXTERNAL MODULE: ./src/utils/hooks/useParams.ts
var useParams = __webpack_require__(9976);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/input/dist/index.esm.js
var input_dist_index_esm = __webpack_require__(979);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(1296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./src/utils/helpers/params.ts
var helpers_params = __webpack_require__(2079);
;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/PackageTabContent.tsx










var PackageTabContent = function(_param) {
    var description = _param.description, placeholder = _param.placeholder, headers = _param.headers, rows = _param.rows, prepend = _param.prepend, props = (0,_object_without_properties/* default */.Z)(_param, [
        "description",
        "placeholder",
        "headers",
        "rows",
        "prepend"
    ]);
    var router = (0,next_router.useRouter)();
    var params = (0,useParams/* default */.Z)(router);
    var query = decodeURIComponent(params.get("query") || "");
    var ref = (0,react.useState)(decodeURIComponent(query)), value = ref[0], setValue = ref[1];
    (0,react.useEffect)(function() {
        if (query) {
            return;
        }
        setValue("");
    }, [
        query
    ]);
    var handleSearchAfter300ms = (0,react.useRef)(lodash_debounce_default()(function(query) {
        var url = "".concat(prepend, "?").concat((0,helpers_params/* updateQueryParam */.rd)(query, params).toString());
        router.push(url, undefined, {
            scroll: false,
            shallow: true
        });
    }, 300));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
                mb: "30px",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                        display: "inline",
                        color: "grey.0",
                        lineHeight: "25px",
                        children: description
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(input_dist_index_esm/* Input */.II, {
                        mt: "30px",
                        p: "10px 15px",
                        fontSize: "14px",
                        lineHeight: "20px",
                        focusBorderColor: "purple.0",
                        placeholder: placeholder,
                        value: value,
                        onChange: function(e) {
                            setValue(e.currentTarget.value);
                            handleSearchAfter300ms.current(e.currentTarget.value);
                        }
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                borderBottom: "1px solid",
                borderBottomColor: "white.4",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                    display: {
                        base: "none",
                        xl: "flex"
                    },
                    children: headers.map(function(param) {
                        var key = param.key, width = param.width, children = param.children;
                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                            width: width,
                            p: "15px",
                            mr: "auto",
                            _last: {
                                mr: "0px"
                            },
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                as: "span",
                                fontSize: "14px",
                                lineHeight: "30px",
                                color: "grey.0",
                                children: children
                            })
                        }, key);
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                children: rows
            })
        ]
    }));
};
/* harmony default export */ var _components_PackageTabContent = (PackageTabContent);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/TabContentComps.tsx













var firstColumnWidth = "420px", secondColumnWidth = "505px", thirdColumnWidth = "100px";
var headers = [
    {
        key: "compositions-name-header",
        children: "Name",
        width: firstColumnWidth
    },
    {
        key: "compositions-referenced-xrd-header",
        children: "Referenced XRD",
        width: secondColumnWidth
    },
    {
        key: "compositions-resources-header",
        children: "Resources",
        width: thirdColumnWidth
    }, 
];
var getExamples = function(data) {
    if (!data.compositions || data.compositions.length < 1) {
        return "";
    }
    var _compositions = (0,_sliced_to_array/* default */.Z)(data.compositions, 1), firstComposition = _compositions[0];
    return firstComposition.name.split(".").slice(0, 2).join(", ");
};
var CompositionsTabContent = function(_param) {
    var data = _param.data, props = (0,_object_without_properties/* default */.Z)(_param, [
        "data"
    ]);
    var router = (0,next_router.useRouter)();
    var params = (0,useParams/* default */.Z)(router);
    var query = decodeURIComponent(params.get("query") || "");
    var prepend = "/".concat(data.packageType.toLowerCase(), "s/").concat(data.account, "/").concat(data.name, "/").concat(data.version);
    var comps = (data.compositions || []).reduce(function(result, composition) {
        var ref, ref1;
        if (!(0,models/* isRegistryComposition */.Qw)(composition)) {
            return result;
        }
        if (!query) {
            return (0,_to_consumable_array/* default */.Z)(result).concat([
                composition
            ]);
        }
        var sanitizedValue = query.toLowerCase().trim();
        if (!composition.name.toLowerCase().includes(sanitizedValue) && !((ref = composition.xrdGroup) === null || ref === void 0 ? void 0 : ref.toLowerCase().includes(sanitizedValue)) && !((ref1 = composition.xrdKind) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase().includes(sanitizedValue))) {
            return result;
        }
        return (0,_to_consumable_array/* default */.Z)(result).concat([
            composition
        ]);
    }, []);
    var rows = (0,react.useMemo)(function() {
        if (comps.length < 1) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                m: "30px 0",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                    textAlign: "center",
                    fontStyle: "oblique",
                    children: "No Compositions found."
                })
            });
        }
        return comps.map(function(row) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
                p: {
                    base: "30px 0",
                    xl: "13px 0 15px 0"
                },
                borderBottom: "1px solid",
                borderBottomColor: "white.4",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        display: {
                            base: "flex",
                            xl: "none"
                        },
                        flexDirection: "column",
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RouteLink/* default */.Z, {
                                prepend: prepend,
                                to: "compositionDetails",
                                params: {
                                    compositionName: row.name,
                                    compositionXrdGroup: row.xrdGroup,
                                    compositionXrdKind: row.xrdKind
                                },
                                width: "100%",
                                fontSize: "14px",
                                fontWeight: 900,
                                textDecoration: "underline",
                                _hover: {
                                    textDecoration: "none"
                                },
                                color: "grey.0",
                                mb: "10px",
                                noOfLines: 1,
                                children: row.name
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                as: "span",
                                fontSize: "14px",
                                lineHeight: "20px",
                                color: "grey.0",
                                mb: "10px",
                                noOfLines: 1,
                                children: row.xrdGroup
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                as: "span",
                                fontSize: "14px",
                                color: "grey.0",
                                children: row.resourceCount
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        display: {
                            base: "none",
                            xl: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                width: firstColumnWidth,
                                p: "15px",
                                mr: "auto",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RouteLink/* default */.Z, {
                                    prepend: prepend,
                                    to: "compositionDetails",
                                    params: {
                                        compositionName: row.name,
                                        compositionXrdGroup: row.xrdGroup,
                                        compositionXrdKind: row.xrdKind
                                    },
                                    fontSize: "14px",
                                    fontWeight: 900,
                                    textDecoration: "underline",
                                    _hover: {
                                        textDecoration: "none"
                                    },
                                    color: "grey.0",
                                    noOfLines: 1,
                                    children: row.name
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
                                width: secondColumnWidth,
                                p: "15px",
                                mr: "auto",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                        as: "span",
                                        display: "block",
                                        fontSize: "14px",
                                        lineHeight: "20px",
                                        color: "grey.0",
                                        textDecoration: "underline",
                                        mb: "8px",
                                        noOfLines: 1,
                                        children: row.xrdKind
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                        as: "span",
                                        display: "block",
                                        fontSize: "14px",
                                        lineHeight: "20px",
                                        color: "grey.0",
                                        noOfLines: 1,
                                        children: row.xrdGroup
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                width: thirdColumnWidth,
                                p: "15px",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                    as: "span",
                                    fontSize: "14px",
                                    color: "grey.0",
                                    children: row.resourceCount
                                })
                            })
                        ]
                    })
                ]
            }, "compositions-row-".concat(row.name, "/").concat(row.xrdGroup, "/").concat(row.xrdKind));
        });
    }, [
        prepend,
        comps
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageTabContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        mt: "35px",
        description: "Compositions compose resources into higher-level APIs defined by a referenced Composite Resource Definition (XRD).",
        placeholder: "Search for Compositions (e.g. ".concat(getExamples(data), ")"),
        headers: headers,
        rows: rows,
        prepend: "".concat(prepend, "/compositions")
    }));
};
/* harmony default export */ var TabContentComps = (CompositionsTabContent);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/TabContentCrds.tsx












var TabContentCrds_firstColumnWidth = "415px", TabContentCrds_secondColumnWidth = "415px", TabContentCrds_thirdColumnWidth = "160px";
var TabContentCrds_headers = [
    {
        key: "crds-kind-header",
        children: "Kind",
        width: TabContentCrds_firstColumnWidth
    },
    {
        key: "crds-group-header",
        children: "Group",
        width: TabContentCrds_secondColumnWidth
    },
    {
        key: "crds-version-header",
        children: "Version",
        width: TabContentCrds_thirdColumnWidth
    }, 
];
var TabContentCrds = function(_param) {
    var data = _param.data, props = (0,_object_without_properties/* default */.Z)(_param, [
        "data"
    ]);
    var router = (0,next_router.useRouter)();
    var params = (0,useParams/* default */.Z)(router);
    var query = decodeURIComponent(params.get("query") || "");
    var prepend = "/".concat(data.packageType.toLowerCase(), "s/").concat(data.account, "/").concat(data.name, "/").concat(data.version);
    var crds = data.resources.reduce(function(result, resource) {
        if (!(0,models/* isRegistryCRD */.lm)(resource)) {
            return result;
        }
        if (!query) {
            return (0,_to_consumable_array/* default */.Z)(result).concat([
                resource
            ]);
        }
        var sanitizedValue = query.toLowerCase().trim();
        if (!resource.group.toLowerCase().includes(sanitizedValue) && !resource.kind.toLowerCase().includes(sanitizedValue) && !resource.storageVersion.toLowerCase().includes(sanitizedValue)) {
            return result;
        }
        return (0,_to_consumable_array/* default */.Z)(result).concat([
            resource
        ]);
    }, []);
    var rows = (0,react.useMemo)(function() {
        if (crds.length < 1) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                m: "30px 0",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                    textAlign: "center",
                    fontStyle: "oblique",
                    children: "No CRD's found."
                })
            });
        }
        return crds.map(function(row) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
                p: {
                    base: "30px 0",
                    xl: "30px 0 24px 0"
                },
                borderBottom: "1px solid",
                borderBottomColor: "white.4",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        display: {
                            base: "flex",
                            xl: "none"
                        },
                        flexDirection: "column",
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RouteLink/* default */.Z, {
                                to: "resourceDetails",
                                prepend: prepend,
                                params: {
                                    resourceGroup: row.group,
                                    resourceKind: row.kind,
                                    resourceVersion: row.storageVersion
                                },
                                fontSize: "14px",
                                fontWeight: 900,
                                textDecoration: "underline",
                                _hover: {
                                    textDecoration: "none"
                                },
                                color: "grey.0",
                                mb: "10px",
                                noOfLines: 1,
                                children: row.kind
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                as: "span",
                                fontSize: "14px",
                                color: "grey.0",
                                mb: "10px",
                                noOfLines: 1,
                                children: row.group
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                as: "span",
                                fontSize: "14px",
                                color: "grey.0",
                                children: row.storageVersion
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        display: {
                            base: "none",
                            xl: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                width: TabContentCrds_firstColumnWidth,
                                mr: "auto",
                                p: "0 15px",
                                noOfLines: 1,
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RouteLink/* default */.Z, {
                                    to: "resourceDetails",
                                    prepend: prepend,
                                    params: {
                                        resourceGroup: row.group,
                                        resourceKind: row.kind,
                                        resourceVersion: row.storageVersion
                                    },
                                    lineHeight: "20px",
                                    fontSize: "14px",
                                    fontWeight: 900,
                                    textDecoration: "underline",
                                    _hover: {
                                        textDecoration: "none"
                                    },
                                    color: "grey.0",
                                    verticalAlign: "text-top",
                                    children: row.kind
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                width: TabContentCrds_secondColumnWidth,
                                mr: "auto",
                                p: "0 15px",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                    as: "span",
                                    fontSize: "14px",
                                    lineHeight: "20px",
                                    color: "grey.0",
                                    noOfLines: 1,
                                    children: row.group
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                width: TabContentCrds_thirdColumnWidth,
                                p: "0 15px",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                    as: "span",
                                    fontSize: "14px",
                                    lineHeight: "18px",
                                    color: "grey.0",
                                    verticalAlign: "text-top",
                                    children: row.storageVersion
                                })
                            })
                        ]
                    })
                ]
            }, "crd-row-".concat(row.group, "/").concat(row.kind, "/").concat(row.storageVersion));
        });
    }, [
        prepend,
        crds
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageTabContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        mt: "35px",
        description: "Custom Resource Definitions (CRDs) define new API types in a Crossplane cluster.",
        placeholder: "Search for CRDs (e.g. ".concat(data.resources.slice(0, 2).map(function(r) {
            return r.kind;
        }).join(", "), ")"),
        headers: TabContentCrds_headers,
        rows: rows,
        prepend: "".concat(prepend, "/crds")
    }));
};
/* harmony default export */ var _components_TabContentCrds = (TabContentCrds);

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(4051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/spinner/dist/index.esm.js
var spinner_dist_index_esm = __webpack_require__(5610);
// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__(9669);
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);
;// CONCATENATED MODULE: ./src/utils/helpers/docs.ts
function findDocsPageUrl(param) {
    var tableOfContents = param.tableOfContents, requestedPageName = param.requestedPageName;
    if (!requestedPageName) {
        return tableOfContents[0];
    }
    var requestedPage = tableOfContents.find(function(param) {
        var name = param.name;
        return name.toLowerCase().replace(" ", "-") === requestedPageName.toLowerCase();
    });
    if (!requestedPage) {
        return tableOfContents[0];
    }
    return requestedPage;
}


// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_array.mjs
var _to_array = __webpack_require__(9637);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/system/dist/index.esm.js + 4 modules
var system_dist_index_esm = __webpack_require__(5818);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/transition/dist/index.esm.js
var transition_dist_index_esm = __webpack_require__(1197);
;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/DocsTreeExpander.tsx





var getActiveStyles = function(isActive) {
    if (isActive) {
        return {
            color: "purple.0"
        };
    }
    return {};
};
var DocsTreeExpander = function(param) {
    var children = param.children, selectedPage = param.selectedPage, title = param.title, titles = param.titles, variant = param.variant;
    var ref = (0,react.useState)({
        isOpen: false
    }), isOpen = ref[0].isOpen, setState = ref[1];
    var styles = (0,system_dist_index_esm/* useStyleConfig */.mq)("TreeLink", {
        variant: variant
    });
    var activeStyles = getActiveStyles(titles.includes((selectedPage === null || selectedPage === void 0 ? void 0 : selectedPage.name) || ""));
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Link */.rU, {
                sx: (0,_object_spread/* default */.Z)({}, styles, activeStyles),
                onClick: function() {
                    return setState({
                        isOpen: !isOpen
                    });
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                    alignItems: "center",
                    justifyContent: "center",
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                            sx: activeStyles,
                            mr: "auto",
                            noOfLines: 2,
                            fontWeight: 600,
                            children: title
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ChevronIcon/* default */.Z, {
                            sx: activeStyles,
                            direction: isOpen ? "down" : "right",
                            size: "sm",
                            width: "11px",
                            height: "11px",
                            ml: "12px"
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(transition_dist_index_esm/* Collapse */.UO, {
                in: isOpen,
                animateOpacity: false,
                children: children
            })
        ]
    });
};
/* harmony default export */ var _components_DocsTreeExpander = (DocsTreeExpander);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/DocsTreeLink.tsx






var DocsTreeLink_getActiveStyles = function(currentPage, selectedPage) {
    if ((currentPage === null || currentPage === void 0 ? void 0 : currentPage.toLowerCase().replace(" ", "-")) === (selectedPage === null || selectedPage === void 0 ? void 0 : selectedPage.name.toLowerCase().replace(" ", "-"))) {
        return {
            color: "purple.0"
        };
    }
    return {};
};
var DocsTabTreeLink = function(_param) {
    var children = _param.children, variant = _param.variant, selectedPage = _param.selectedPage, params = _param.params, _noOfLines = _param.noOfLines, noOfLines = _noOfLines === void 0 ? 2 : _noOfLines, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "variant",
        "selectedPage",
        "params",
        "noOfLines"
    ]);
    var styles = (0,system_dist_index_esm/* useStyleConfig */.mq)("TreeLink", {
        variant: variant
    });
    var activeStyles = DocsTreeLink_getActiveStyles(params.pageName, selectedPage);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RouteLink/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        sx: (0,_object_spread/* default */.Z)({}, styles, activeStyles),
        to: "packageDocsTab",
        params: params
    }, props), {
        scroll: false,
        shallow: false,
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
            noOfLines: noOfLines,
            children: children
        })
    }));
};
/* harmony default export */ var DocsTreeLink = (DocsTabTreeLink);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/DocsTree.tsx










function getExpanderVariant(index) {
    if (index < 1) {
        return "root";
    }
    return "child";
}
function recursivelyUpdateChildren(param) {
    var currentPage = param.currentPage, selectedPage = param.selectedPage, params = param.params, node = param.node;
    var titleParts = currentPage.name.split("/");
    var _titleParts = (0,_sliced_to_array/* default */.Z)(titleParts, 1), firstTitlePart = _titleParts[0];
    var ref = (0,_sliced_to_array/* default */.Z)(titleParts.splice(-1), 1), lastTitlePart = ref[0];
    var children = node.props.children || [];
    var updatedNodeIndex = children.findIndex(function(child) {
        return child.props.title === firstTitlePart;
    });
    if (updatedNodeIndex < 0) {
        // New node
        return (0,_to_consumable_array/* default */.Z)(children).concat([
            titleParts.reduce(function(child, titlePart, index) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_DocsTreeExpander, {
                    title: titlePart,
                    titles: [
                        currentPage.name
                    ],
                    selectedPage: selectedPage,
                    variant: getExpanderVariant(index),
                    children: [
                        child
                    ]
                }, titlePart);
            }, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DocsTreeLink, {
                title: currentPage.name,
                variant: "child",
                params: params,
                selectedPage: selectedPage,
                children: lastTitlePart
            }, currentPage.location)), 
        ]);
    }
    // Existing node
    var _titleParts1 = (0,_to_array/* default */.Z)(titleParts), remainingTitleParts = _titleParts1.slice(1);
    var child = children[updatedNodeIndex];
    var titles = child.props.titles || [];
    return (0,_to_consumable_array/* default */.Z)(children.slice(0, updatedNodeIndex)).concat([
        /*#__PURE__*/ (0,react.cloneElement)(child, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, child.props), {
            titles: (0,_to_consumable_array/* default */.Z)(titles).concat([
                currentPage.name
            ]),
            children: recursivelyUpdateChildren({
                currentPage: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, currentPage), {
                    name: (0,_to_consumable_array/* default */.Z)(remainingTitleParts).concat([
                        lastTitlePart
                    ]).join("/")
                }),
                selectedPage: selectedPage,
                params: params,
                node: child
            })
        })), 
    ], (0,_to_consumable_array/* default */.Z)(children.slice(updatedNodeIndex + 1)));
}
var DocsTree = function(param) {
    var tableOfContents = param.tableOfContents, selectedPage = param.selectedPage, incompleteParams = param.incompleteParams;
    return tableOfContents.reduce(function(node, currentPage) {
        var params = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, incompleteParams), {
            pageName: currentPage.name
        });
        if (currentPage.name.includes("/")) {
            // Nested link
            return /*#__PURE__*/ (0,react.cloneElement)(node, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, node.props), {
                children: recursivelyUpdateChildren({
                    currentPage: currentPage,
                    selectedPage: selectedPage,
                    params: params,
                    node: node
                })
            }));
        }
        var children = node.props.children || [];
        var gtmClass = "provder-".concat(currentPage.name.split(" ").join("").toLowerCase(), "-tab");
        // Root link
        return /*#__PURE__*/ (0,react.cloneElement)(node, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, node.props), {
            children: (0,_to_consumable_array/* default */.Z)(children).concat([
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(DocsTreeLink, {
                    className: gtmClass,
                    title: currentPage.name,
                    variant: "root",
                    params: params,
                    selectedPage: selectedPage,
                    children: currentPage.name
                }, currentPage.name), 
            ])
        }));
    }, /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
        role: "TreeOfContents"
    }));
};
/* harmony default export */ var _components_DocsTree = (DocsTree);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/TabContentDocs.tsx













var TabContentDocs = function(_param) {
    var data = _param.data, props = (0,_object_without_properties/* default */.Z)(_param, [
        "data"
    ]);
    var router = (0,next_router.useRouter)();
    var requestedPageName = (0,react.useMemo)(function() {
        var pageName = router.query.pageName;
        if (!pageName) {
            return "";
        }
        if (!Array.isArray(pageName)) {
            return pageName;
        }
        return pageName.join("/");
    }, [
        router
    ]);
    var ref = (0,react.useState)(""), pageMarkdown = ref[0], setPageMarkdown = ref[1];
    var selectedPage = (0,react.useMemo)(function() {
        var ref;
        return {
            selectedPage: findDocsPageUrl({
                tableOfContents: ((ref = data.docs) === null || ref === void 0 ? void 0 : ref.tableOfContents) || [],
                requestedPageName: requestedPageName
            })
        };
    }, [
        data,
        requestedPageName
    ]).selectedPage;
    (0,react.useEffect)(function() {
        if (!selectedPage || requestedPageName === selectedPage.name) {
            return;
        }
        function getPageMarkdown() {
            return _getPageMarkdown.apply(this, arguments);
        }
        function _getPageMarkdown() {
            _getPageMarkdown = (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
                var result;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return axios_default().get(selectedPage.location);
                        case 2:
                            result = _ctx.sent;
                            setPageMarkdown(result.data.toString());
                        case 4:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return _getPageMarkdown.apply(this, arguments);
        }
        getPageMarkdown();
    }, [
        requestedPageName,
        selectedPage
    ]);
    if (!data.docs) {
        return null;
    }
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: "100%",
        id: "docs"
    }, props), {
        flexDirection: {
            base: "column",
            lg: "row"
        },
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                width: "100%",
                maxWidth: {
                    base: "auto",
                    lg: "270px"
                },
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                    flexDirection: "column",
                    width: "100%",
                    position: "sticky",
                    top: "0px",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
                        width: "100%",
                        maxHeight: "100vh",
                        overflow: "auto",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Heading */.X6, {
                                as: "h3",
                                fontSize: "14px",
                                lineHeight: "20px",
                                mt: "38px",
                                pb: "12px",
                                pl: "8px",
                                fontWeight: 600,
                                color: "grey.2",
                                children: "Contents"
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_DocsTree, {
                                tableOfContents: data.docs.tableOfContents,
                                selectedPage: selectedPage,
                                incompleteParams: {
                                    packageType: data.packageType,
                                    packageOwner: data.account,
                                    packageName: data.name,
                                    packageVersion: data.version
                                }
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                minWidth: {
                    base: "100%",
                    lg: "70%"
                },
                pt: "12px",
                borderLeftWidth: {
                    base: "0",
                    lg: "1px"
                },
                borderLeftColor: "white.4",
                borderLeftStyle: "solid",
                borderTopWidth: {
                    base: "1px",
                    lg: "0"
                },
                borderTopColor: "white.4",
                borderTopStyle: "solid",
                pl: {
                    base: "12px",
                    lg: "80px"
                },
                minHeight: "500px",
                children: pageMarkdown ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Markdown/* default */.Z, {
                    lineHeight: "25px",
                    fontSize: "14px",
                    color: "grey.0",
                    children: pageMarkdown
                }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                    alignItems: "center",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(spinner_dist_index_esm/* Spinner */.$, {
                        role: "Spinner",
                        color: "black.0"
                    })
                })
            })
        ]
    }));
};
/* harmony default export */ var _components_TabContentDocs = (TabContentDocs);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/TabContentXrds.tsx












var TabContentXrds_firstColumnWidth = "415px", TabContentXrds_secondColumnWidth = "415px", TabContentXrds_thirdColumnWidth = "160px";
var TabContentXrds_headers = [
    {
        key: "xrds-kind-header",
        children: "Kind",
        width: TabContentXrds_firstColumnWidth
    },
    {
        key: "xrds-group-header",
        children: "Group",
        width: TabContentXrds_secondColumnWidth
    },
    {
        key: "xrds-version-header",
        children: "Version",
        width: TabContentXrds_thirdColumnWidth
    }, 
];
var TabContentXrds = function(_param) {
    var data = _param.data, props = (0,_object_without_properties/* default */.Z)(_param, [
        "data"
    ]);
    var router = (0,next_router.useRouter)();
    var params = (0,useParams/* default */.Z)(router);
    var query = decodeURIComponent(params.get("query") || "");
    var xrds = data.resources.reduce(function(result, resource) {
        if (!(0,models/* isRegistryXRD */.YM)(resource)) {
            return result;
        }
        if (!query) {
            return (0,_to_consumable_array/* default */.Z)(result).concat([
                resource
            ]);
        }
        var sanitizedValue = query.toLowerCase().trim();
        if (!resource.group.toLowerCase().includes(sanitizedValue) && !resource.kind.toLowerCase().includes(sanitizedValue) && !resource.referenceableVersion.toLowerCase().includes(sanitizedValue)) {
            return result;
        }
        return (0,_to_consumable_array/* default */.Z)(result).concat([
            resource
        ]);
    }, []);
    var prepend = "/".concat(data.packageType.toLowerCase(), "s/").concat(data.account, "/").concat(data.name, "/").concat(data.version);
    var rows = (0,react.useMemo)(function() {
        if (xrds.length < 1) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                m: "30px 0",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                    textAlign: "center",
                    fontStyle: "oblique",
                    children: "No XRD's found."
                })
            });
        }
        return xrds.map(function(row) {
            return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
                p: {
                    base: "30px 0",
                    xl: "13px 0 15px 0"
                },
                borderBottom: "1px solid",
                borderBottomColor: "white.4",
                width: "100%",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        display: {
                            base: "flex",
                            xl: "none"
                        },
                        flexDirection: "column",
                        alignItems: "flex-start",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RouteLink/* default */.Z, {
                                prepend: prepend,
                                to: "resourceDetails",
                                params: {
                                    resourceGroup: row.group,
                                    resourceKind: row.kind,
                                    resourceVersion: row.referenceableVersion
                                },
                                fontSize: "14px",
                                fontWeight: 900,
                                textDecoration: "underline",
                                _hover: {
                                    textDecoration: "none"
                                },
                                color: "grey.0",
                                mb: "10px",
                                noOfLines: 1,
                                children: row.kind
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                as: "span",
                                fontSize: "14px",
                                color: "grey.0",
                                mb: "10px",
                                noOfLines: 1,
                                children: row.group
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                as: "span",
                                fontSize: "14px",
                                color: "grey.0",
                                children: row.referenceableVersion
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        display: {
                            base: "none",
                            xl: "flex"
                        },
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                width: TabContentXrds_firstColumnWidth,
                                p: "15px",
                                mr: "auto",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RouteLink/* default */.Z, {
                                    prepend: prepend,
                                    to: "resourceDetails",
                                    params: {
                                        resourceGroup: row.group,
                                        resourceKind: row.kind,
                                        resourceVersion: row.referenceableVersion
                                    },
                                    fontSize: "14px",
                                    fontWeight: 900,
                                    textDecoration: "underline",
                                    _hover: {
                                        textDecoration: "none"
                                    },
                                    color: "grey.0",
                                    noOfLines: 1,
                                    children: row.kind
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                width: TabContentXrds_secondColumnWidth,
                                p: "15px",
                                mr: "auto",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                    as: "span",
                                    fontSize: "14px",
                                    color: "grey.0",
                                    noOfLines: 1,
                                    children: row.group
                                })
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                width: TabContentXrds_thirdColumnWidth,
                                p: "15px",
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                    as: "span",
                                    fontSize: "14px",
                                    color: "grey.0",
                                    children: row.referenceableVersion
                                })
                            })
                        ]
                    })
                ]
            }, "xrd-row-".concat(row.group, "/").concat(row.kind, "/").concat(row.referenceableVersion));
        });
    }, [
        xrds,
        prepend
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageTabContent, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        mt: "35px",
        description: "Composite Resource Definitions (XRDs) define new API types that are implemented by one or more Compositions.",
        placeholder: "Search for XRDs (e.g. ".concat(data.resources.slice(0, 2).map(function(r) {
            return r.kind;
        }).join(", "), ")"),
        headers: TabContentXrds_headers,
        rows: rows,
        prepend: "".concat(prepend, "/xrds")
    }));
};
/* harmony default export */ var _components_TabContentXrds = (TabContentXrds);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/__components__/TabTriggerLink.tsx





var TabTriggerLink = function(_param) {
    var children = _param.children, data = _param.data, append = _param.append, props = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "data",
        "append"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RouteLink/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        to: "packageDetails",
        append: append,
        params: {
            packageType: data.packageType,
            packageOwner: data.account,
            packageName: data.name,
            packageVersion: data.version
        },
        scroll: false,
        shallow: true
    }, props), {
        children: children
    }));
};
/* harmony default export */ var _components_TabTriggerLink = (TabTriggerLink);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/_useTabs.tsx













function createTab(type, index, Link, Content, hidden) {
    return {
        type: type,
        index: index,
        Link: Link,
        Content: Content,
        hidden: hidden
    };
}
function createDocsTab(param) {
    var index = param.index, data = param.data;
    return createTab(tabs/* PackageTabs.Docs */.oV.Docs, index, function(props) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_TabTriggerLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            data: data,
            append: "/docs"
        }, props), {
            children: "Docs"
        }));
    }, function(props) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_TabContentDocs, (0,_object_spread/* default */.Z)({
            data: data
        }, props));
    }, !data.docs);
}
function createXrdsTab(param) {
    var index = param.index, data = param.data;
    return createTab(tabs/* PackageTabs.XRDs */.oV.XRDs, index, function(props) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(_components_TabTriggerLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            data: data,
            append: "/xrds",
            className: "xrds-tab"
        }, props), {
            children: [
                "XRDs (",
                data.resources.length,
                ")"
            ]
        }));
    }, function(props) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_TabContentXrds, (0,_object_spread/* default */.Z)({
            data: data
        }, props));
    });
}
function createCrdsTab(param) {
    var index = param.index, data = param.data;
    return createTab(tabs/* PackageTabs.CRDs */.oV.CRDs, index, function(props) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(_components_TabTriggerLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            data: data,
            append: "/crds",
            className: "provider-crds-tab"
        }, props), {
            children: [
                "CRDs (",
                data.resources.length,
                ")"
            ]
        }));
    }, function(props) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_TabContentCrds, (0,_object_spread/* default */.Z)({
            data: data
        }, props));
    });
}
function createCompositionsTab(param) {
    var index = param.index, data = param.data;
    return createTab(tabs/* PackageTabs.Compositions */.oV.Compositions, index, function(props) {
        var ref;
        /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(_components_TabTriggerLink, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            data: data,
            append: "/compositions",
            className: "composition-tab"
        }, props), {
            children: [
                "Compositions (",
                ((ref = data.compositions) === null || ref === void 0 ? void 0 : ref.length) || 0,
                ")"
            ]
        }));
    }, function(props) {
        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabContentComps, (0,_object_spread/* default */.Z)({
            data: data
        }, props));
    });
}
function createTabs(props) {
    for(var _len = arguments.length, getTabFns = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        getTabFns[_key - 1] = arguments[_key];
    }
    return getTabFns.reduce(function(param, getTab, index) {
        var allTabs = param.allTabs, requestedTab = param.requestedTab;
        var currentTab = getTab((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
            index: index
        }));
        var nextTabs = (0,_to_consumable_array/* default */.Z)(allTabs).concat([
            currentTab
        ]);
        if (currentTab.type === props.requestedTabType) {
            return {
                allTabs: nextTabs,
                requestedTab: currentTab
            };
        }
        return {
            allTabs: nextTabs,
            requestedTab: requestedTab
        };
    }, {
        allTabs: [],
        requestedTab: undefined
    });
}
function getAllTabs(props) {
    switch(props.data.packageType){
        case upbound_graphql/* RegistryPackageType.Configuration */.l.Configuration:
            {
                return createTabs(props, createDocsTab, createXrdsTab, createCompositionsTab);
            }
        case upbound_graphql/* RegistryPackageType.Provider */.l.Provider:
            {
                return createTabs(props, createDocsTab, createCrdsTab);
            }
    }
}
function getDefaultTab(props) {
    if (props.requestedTab) {
        return props.requestedTab;
    }
    var _allTabs = (0,_sliced_to_array/* default */.Z)(props.allTabs, 1), firstTab = _allTabs[0];
    if (firstTab.hidden) {
        var firstVisibleTab = props.allTabs.find(function(tab) {
            return !tab.hidden;
        });
        if (!firstVisibleTab) {
            throw new Error("No visible tab groups to choose from");
        }
        return firstVisibleTab;
    }
    return firstTab;
}
function useTabs(param) {
    var data = param.data, requestedTabType = param.requestedTabType;
    var ref = (0,react.useMemo)(function() {
        return getAllTabs({
            data: data,
            requestedTabType: requestedTabType
        });
    }, [
        data,
        requestedTabType
    ]), allTabs = ref.allTabs, requestedTab = ref.requestedTab;
    var defaultTab = getDefaultTab({
        allTabs: allTabs,
        requestedTab: requestedTab
    });
    var ref1 = (0,react.useState)(defaultTab), activeTab = ref1[0], setActiveTab = ref1[1];
    (0,react.useEffect)(function() {
        setActiveTab(getDefaultTab({
            allTabs: allTabs,
            requestedTab: requestedTab
        }));
    }, [
        allTabs,
        requestedTab
    ]);
    return {
        allTabs: allTabs,
        requestedTab: requestedTab,
        defaultTab: defaultTab,
        activeTab: activeTab,
        setActiveTab: setActiveTab
    };
}
/* harmony default export */ var _useTabs = (useTabs);

;// CONCATENATED MODULE: ./src/pages/[packageType]/[packageAccount]/[packageName]/[packageVersion]/_layout.tsx























function getBaseCodeBlock(data) {
    var packageUrl = "".concat(config/* CONFIG_REGISTRY_HOST */.hk, "/").concat(data.account, "/").concat(data.name, ":").concat(data.version);
    return "apiVersion: pkg.crossplane.io/v1\nkind: ".concat((0,dist_es2015/* capitalCase */.I)(data.packageType), "\nmetadata:\n  name: ").concat(data.name, "\nspec:\n  package: ").concat(packageUrl);
}
function getPrivateCodeBlock() {
    return "\n  packagePullSecrets:\n    - name: package-pull-secret";
}
function getCodeBlock(data) {
    var base = getBaseCodeBlock(data);
    if (data.public === false) {
        return base + getPrivateCodeBlock();
    }
    return base;
}
var PackageDetailsLayout = function(param) {
    var data = param.data, requestedTabType = param.requestedTabType;
    var ref;
    var ref1 = (0,_sliced_to_array/* default */.Z)(data.versions || [], 1), tmp = ref1[0], latestVersion = tmp === void 0 ? "latest" : tmp;
    var ref2 = (0,react.useState)(false), isInstallModalVisible = ref2[0], setIsInstallModalVisible = ref2[1];
    var ref3 = _useTabs({
        data: data,
        requestedTabType: requestedTabType
    }), allTabs = ref3.allTabs, activeTab = ref3.activeTab, setActiveTab = ref3.setActiveTab;
    var ref4 = (0,_sliced_to_array/* default */.Z)((0,usePageScrollPadding/* default */.Z)(), 1), mobileRef = ref4[0];
    var ref5 = (0,_sliced_to_array/* default */.Z)(hooks_usePageScrollTo(!requestedTabType), 1), scrollRef = ref5[0];
    var ref6 = (0,react.useState)(!!((ref = data.userSettings) === null || ref === void 0 ? void 0 : ref.starred)), isStarred = ref6[0], setIsStarred = ref6[1];
    var currentUser = (0,contexts_currentUser/* useCurrentUser */.x)().currentUser;
    var router = (0,next_router.useRouter)();
    var ref7 = (0,_sliced_to_array/* default */.Z)((0,upbound_graphql/* useUpdateUserSettingsMutation */.m9)(), 1), updateUserSettings = ref7[0];
    var onStarClick = function() {
        if (!currentUser) {
            router.push((0,urls/* accountsLoginUrl */.ST)(router.asPath));
        } else {
            updateUserSettings({
                variables: {
                    payload: {
                        account: data.account,
                        name: data.name,
                        starred: !isStarred
                    }
                }
            }).then(function() {
                setIsStarred(!isStarred);
            }).catch(function(error) {
                return (0,routing/* tryCatch */.Y3)(error);
            });
        }
    };
    // TODO: When releasing Family Providers to GA, remove check for Upbound account
    var accounts = (0,contexts_accounts/* useAccounts */.x)().accounts;
    var isUpboundMember = !!accounts.find(function(a) {
        return a.id === "upbound";
    });
    var repositoryId = data.repositoryId, familyRepositoryId = data.familyRepositoryId;
    var isFamilyProvider = familyRepositoryId && repositoryId === familyRepositoryId;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(PageTemplate/* default */.Z, {
        title: "".concat(data.account, "/").concat(data.name, "@").concat(data.version),
        mobileRef: mobileRef,
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
                width: "100%",
                maxWidth: "1140px",
                p: {
                    base: "30px",
                    md: "50px 70px 0 70px",
                    xl: "50px 15px 0 15px"
                },
                m: "0 auto",
                children: [
                    data.versions && data.version !== "latest" && data.version !== data.versions[0] && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(Notification/* default */.Z, {
                        mb: "29px",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Text */.xv, {
                                color: "grey.0",
                                as: "span",
                                children: [
                                    "You are viewing an outdated version of this ",
                                    data.packageType.toLowerCase(),
                                    "."
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(RouteLink/* default */.Z, {
                                to: "packageDetails",
                                params: {
                                    packageType: data.packageType,
                                    packageOwner: data.account,
                                    packageName: data.name,
                                    packageVersion: latestVersion
                                },
                                ml: "12px",
                                color: "purple.0",
                                textDecoration: "underline",
                                _hover: {
                                    textDecoration: "none"
                                },
                                children: "Go to Latest"
                            })
                        ]
                    }),
                    isUpboundMember && isFamilyProvider ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_FamilyProviderHeader, {
                        data: data,
                        setIsInstallModalVisible: setIsInstallModalVisible,
                        onStarClick: onStarClick,
                        isStarred: isStarred
                    }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(_components_PackageHeader, {
                        data: data,
                        setIsInstallModalVisible: setIsInstallModalVisible,
                        onStarClick: onStarClick,
                        isStarred: isStarred
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                width: "100%",
                height: "1px",
                background: "white.4",
                mt: {
                    base: "35px",
                    md: "70px"
                }
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                ref: scrollRef
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                width: "100%",
                maxWidth: "1140px",
                p: {
                    base: "50px 30px 30px 30px",
                    md: "50px 70px 0 70px",
                    xl: "50px 15px 0 15px"
                },
                m: "0 auto",
                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
                    children: [
                        data.packageType !== upbound_graphql/* RegistryPackageType.Provider */.l.Provider && data.dependsOn.length > 1 && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
                            mb: "50px",
                            children: [
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                    as: "span",
                                    fontWeight: 900,
                                    color: "black.0",
                                    fontSize: "20px",
                                    lineHeight: "25px",
                                    mb: "20px",
                                    display: "inline-block",
                                    children: "Dependencies"
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                    mb: {
                                        base: "30px",
                                        md: "19px"
                                    },
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Text */.xv, {
                                        display: "inline",
                                        color: "grey.0",
                                        lineHeight: "25px",
                                        children: [
                                            "Dependencies are packages that this ",
                                            data.packageType.toLowerCase(),
                                            " uses."
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                                    children: data.dependsOn.map(function(dependency, index) {
                                        var ref = (0,_sliced_to_array/* default */.Z)(dependency.displayName.split("/").reverse(), 1), packageName = ref[0];
                                        return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                                            width: "100%",
                                            borderBottom: "1px solid",
                                            borderBottomColor: "white.4",
                                            alignItems: {
                                                base: "flex-start",
                                                md: "center"
                                            },
                                            flexWrap: "wrap",
                                            flexDirection: {
                                                base: "column",
                                                md: "row"
                                            },
                                            p: {
                                                base: "30px 0",
                                                md: "30px 15px 28px 15px"
                                            },
                                            borderTopWidth: "0px",
                                            borderTopStyle: "solid",
                                            borderTopColor: "white.4",
                                            _first: {
                                                borderTopWidth: "1px"
                                            },
                                            children: [
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                                    display: {
                                                        base: "block",
                                                        md: "inline"
                                                    },
                                                    fontWeight: 900,
                                                    color: "black.0",
                                                    children: packageName
                                                }),
                                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
                                                    mt: {
                                                        base: "10px",
                                                        md: "18px"
                                                    },
                                                    width: "100%",
                                                    children: [
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                                            display: {
                                                                base: "inline",
                                                                md: "none"
                                                            },
                                                            as: "span",
                                                            color: "grey.0",
                                                            fontSize: "14px",
                                                            lineHeight: "20px",
                                                            children: (0,dist_es2015/* capitalCase */.I)(dependency.packageType.toLowerCase())
                                                        }),
                                                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                                            display: {
                                                                base: "none",
                                                                md: "inline"
                                                            },
                                                            as: "span",
                                                            color: "grey.1",
                                                            fontSize: "14px",
                                                            lineHeight: "20px",
                                                            children: dependency.displayName
                                                        })
                                                    ]
                                                })
                                            ]
                                        }, "".concat(dependency.id, "-").concat(dependency.packageType, "-").concat(dependency.version, "-").concat(index));
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TabGroup/* default */.Z, {
                            allTabs: allTabs,
                            activeTab: activeTab,
                            setActiveTab: setActiveTab
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist_index_esm/* Modal */.u_, {
                size: "3xl",
                isOpen: isInstallModalVisible,
                onClose: function() {
                    return setIsInstallModalVisible(false);
                },
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* ModalOverlay */.ZA, {}),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist_index_esm/* ModalContent */.hz, {
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* ModalCloseButton */.ol, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(dist_index_esm/* ModalBody */.fe, {
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PackageIcon/* default */.Z, {
                                        data: data,
                                        width: "48px",
                                        height: "48px",
                                        mb: "10px"
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Heading */.X6, {
                                        as: "h4",
                                        size: "sm",
                                        mb: "20px",
                                        children: [
                                            "Install ",
                                            data.displayName
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Text */.xv, {
                                        mb: "30px",
                                        children: [
                                            "The following manifest can be used to install this package in your control plane. After you have connected to your control plane run ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Code */.EK, {
                                                padding: "0px 5px 0px 5px",
                                                children: "kubectl apply -f"
                                            }),
                                            " after copying the following into a local file."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PrismHighlighter/* default */.Z, {
                                        language: "yaml",
                                        plugins: [
                                            "line-numbers",
                                            "copy-to-clipboard"
                                        ],
                                        copyIconProps: {
                                            className: "copy-manifest-button"
                                        },
                                        mb: "55px",
                                        children: getCodeBlock(data)
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Text */.xv, {
                                        textAlign: "center",
                                        size: "sm",
                                        color: "grey.1",
                                        children: [
                                            "For more detailed instructions on how to install packages read the",
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Link */.rU, {
                                                href: urls/* UPBOUND_DOCS_URL */.NQ,
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                fontSize: "12px",
                                                color: "purple.0",
                                                _hover: {
                                                    textDecoration: "none"
                                                },
                                                children: "Upbound Documentation"
                                            }),
                                            " ",
                                            "or",
                                            " ",
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Link */.rU, {
                                                href: "mailto:info@upbound.io",
                                                rel: "noopener noreferrer",
                                                fontSize: "12px",
                                                color: "purple.0",
                                                _hover: {
                                                    textDecoration: "none"
                                                },
                                                children: "Contact Us"
                                            }),
                                            " ",
                                            "and we can help get you started."
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var _layout = (PackageDetailsLayout);


/***/ }),

/***/ 949:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "oS": function() { return /* binding */ apolloErrors; },
  "NQ": function() { return /* binding */ props; },
  "Y3": function() { return /* binding */ tryCatch; }
});

// UNUSED EXPORTS: notFound, redirect

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@next-safe/middleware/dist/document/index.mjs + 67 modules
var dist_document = __webpack_require__(2534);
;// CONCATENATED MODULE: ./src/utils/guards/status.ts
function isStatus(r) {
    if (typeof r === "object" && r !== null) {
        return "status" in r;
    }
    return false;
}
function getStatus(r) {
    if (!isStatus(r)) {
        return;
    }
    return r.status;
}


;// CONCATENATED MODULE: ./src/utils/helpers/routing.ts




function notFound() {
    return {
        notFound: true
    };
}
function props(c, p) {
    var nonce = (0,dist_document/* getCreateCtxNonceIdempotent */.P4)(c);
    return {
        props: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
            nonce: nonce,
            params: JSON.parse(JSON.stringify(c.params || {}))
        })
    };
}
function redirect(destination) {
    var permanent = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    return {
        redirect: {
            permanent: permanent,
            destination: destination
        }
    };
}
function apolloErrors(graphQLErrors) {
    if (graphQLErrors === null || graphQLErrors === void 0 ? void 0 : graphQLErrors.some(function(gqlError) {
        var ref;
        return getStatus(gqlError === null || gqlError === void 0 ? void 0 : (ref = gqlError.extensions) === null || ref === void 0 ? void 0 : ref.response) === 404;
    })) {
        return redirect("/404");
    }
    return redirect("/500");
}
function isErrorResponse(unknownObject) {
    var requiredKeys = [
        "graphQLErrors",
        "networkError"
    ];
    if (typeof unknownObject !== "object") {
        return false;
    }
    for(var unknownKey in unknownObject){
        if (requiredKeys.includes(unknownKey)) {
            return true;
        }
    }
    return false;
}
function tryCatch(error) {
    if (!isErrorResponse(error)) {
        return redirect("/500");
    }
    return apolloErrors(error.graphQLErrors);
}



/***/ })

}]);